import { useMediaDownload } from '@/api/media'
import { DownloadButton } from '@/components/ui/Button'

export default function DownloadTemplateTim() {
  const { mutate, isLoading } = useMediaDownload()

  const handleDownload = () => {
    mutate({ path: 'template_kpi_leadership_tim.xlsx', fileName: 'template_kpi_leadership_tim.xlsx' })
  }
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="download-template-kpi-tim">Download Template KPI Leadership Tim & Staff</label>
      <DownloadButton id="download-template-kpi-tim" onClick={handleDownload} loading={isLoading}>
        Template KPI Leadership Tim & Staff
      </DownloadButton>
    </div>
  )
}
